import { useSearchParams, useRouter, usePathname } from "next/navigation";
import { useEffect, useState } from "react";
import qs from "query-string";

export default function useExtractedSearchParam(queryParam: string) {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const { replace } = useRouter();
  const [extractedQueryParam, setExtractedQueryParam] = useState<
    string | undefined
  >(undefined);

  useEffect(() => {
    if (!searchParams) {
      return;
    }

    if (!pathname) {
      return;
    }

    const extractedQueryParam = searchParams.get(queryParam);

    if (!extractedQueryParam) {
      return;
    }

    setExtractedQueryParam(extractedQueryParam);

    const searchParamsWithOutExtractedQueryParam: {
      [key: string]: string[] | string;
    } = {};

    Array.from(searchParams.keys()).forEach((key) => {
      if (key === queryParam) {
        return;
      }

      // if you dont use getAll you lose the ability to have multiple values for a key
      // so can't just use Object.fromEntries(searchParams.entries()) — it only returns single values
      searchParamsWithOutExtractedQueryParam[key] = searchParams.getAll(key);
    });

    replace(
      qs.stringifyUrl({
        url: pathname,
        query: searchParamsWithOutExtractedQueryParam,
      }),
      {}
    );
  }, [pathname, queryParam, replace, searchParams]);

  return extractedQueryParam;
}
